<template>
  <div class="app-container">
    <!-- 维护提示模态框 -->
    <!-- 
    <div class="maintenance-modal" v-if="showMaintenanceModal">
      <div class="maintenance-modal-content">
        <h3>系统维护通知</h3>
        <div class="maintenance-message">
          <p>由于服务器出了问题，正在维护，目前无法为您提供软件下载，本网站将在3-5个工作日后恢复正常；</p>
          <p>请将您的邮箱或电话发送到<a href="mailto:codingroad@2925.com" class="modal-email-link">codingroad@2925.com</a>，当服务器恢复正常，我将第一时间通知您！</p>
        </div>
        <button class="maintenance-close-btn" @click="closeMaintenanceModal">我知道了</button>
      </div>
    </div>
    -->
    
    <!-- Prompt Sidebar -->
    <!-- 
    <div class="announcement-sidebar" v-if="showAnnouncement">
      <button class="close-button" @click="closeAnnouncement">×</button>
      <h3>友情提示</h3>
      <div class="announcement-content">
        <p>
          1、浏览器下载后会提示“通常不会下载toPDF.exe，请在打开前确保信任toPDF.exe。”
        </p>
        <p class="trust-notice">
          请选择"保留"并信任此程序，本软件不存在任何病毒或捆绑。
        </p>
        <p>
          2、如果您对此类软件有稳定的需求，请尽管将您的使用意见发送到
          <a href="mailto:codingroad@2925.com" class="sidebar-email-link">codingroad@2925.com</a>
          　如果您的需求与很多人产生共鸣，我们一定及时修改并更新。 
        </p>
      </div>
    </div>
    -->
    <!-- Slogan Section -->
    <header class="hero-section">
      <div class="container">
        <h1 class="main-title">批量转换PDF利器，提效办公神助手</h1>
        <div class="feature-list">
          <p class="feature-item">支持批量将Word、Excel、PowerPoint、图片文件、txt文件转换为PDF</p>
          <p class="feature-item">支持合并PDF文件</p>
        </div>
        <!-- 产品下载链接 -->
        <div class="download-section">
          <router-link to="/download" class="download-btn" :class="{ 'disabled-btn': downloadDisabled }">
            <span class="btn-text">立即下载</span>
            <span class="btn-icon">→</span>
          </router-link>
        </div>
      </div>
    </header>

    <div class="container">
      <!-- 产品介绍 -->
      <section class="intro-section">
        <h2 class="section-title">产品介绍</h2>
        <div class="intro-content">
          <p>
            toPDF是一款强大且易于使用的PDF转换工具，支持批量将Word、Excel、PowerPoint、图片和TXT文件快速转换为PDF，并能轻松合并多个PDF文档。拥有简洁友好的用户界面和高效的转换速度，toPDF 助您轻松管理各种文档，显著提升办公效率。toPDF是您不可或缺的办公利器。
          </p>
        </div>
      </section>

      <!-- 图片展示区 -->
      <section class="showcase-section">
        <h2 class="section-title">功能展示</h2>
        <div class="showcase-container">
          <div class="showcase-image">
            <img :src="showcaseImage" alt="功能展示" class="feature-image">
          </div>
        </div>
      </section>

      <!-- 视频展示区 -->
      <section class="video-section">
        <h2 class="section-title">演示示例</h2>
        <div class="video-container">
          <div class="video-wrapper" 
            @mouseenter="showControls = true"
            @mouseleave="showControls = false">
            <!-- 遮罩层，当维护模态框显示时阻止视频交互 -->
            <!-- <div v-if="showMaintenanceModal" class="video-block-overlay"></div> -->
            <video 
              ref="videoPlayer"
              class="feature-video" 
              preload="metadata"
              :src="demoVideo"
              :poster="videoPoster"
              @click="!showMaintenanceModal && togglePlay"
              @timeupdate="updateProgress"
              @loadedmetadata="initVideo"
              @ended="handleVideoEnd"
              @fullscreenchange="handleFullscreenChange"
              style="background: transparent;">
              您的浏览器不支持 HTML5 视频播放。
            </video>
            <!-- 自定义播放按钮 -->
            <div v-if="!isPlaying && !showMaintenanceModal" class="custom-play-button" @click="togglePlay">
              <span>▶</span>
            </div>
            <!-- 暂停按钮 -->
            <div v-if="isPlaying && !showMaintenanceModal" class="control-buttons">
              <div class="control-button pause-button" @click="togglePlay">
                <span>⏸</span>
              </div>
            </div>
            <!-- 视频控制栏 -->
            <div class="video-controls" v-show="showControls">
              <!-- 进度条 -->
              <div class="progress-bar" @click="seek">
                <div class="progress" :style="{ width: progress + '%' }"></div>
              </div>
              <div class="controls-bottom">
                <!-- 时间显示 -->
                <div class="time-display">
                  {{ currentTime }} / {{ duration }}
                </div>
                <!-- 全屏按钮 -->
                <div class="fullscreen-button" @click="toggleFullscreen">
                  <span>⛶</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 联系我们 -->
      <footer class="contact-section">
        <h3 class="section-title">联系我们</h3>
        <div class="contact-content">
          <p>
            <span class="contact-label">使用反馈</span>
            <span class="contact-label">商务合作</span>
            <span class="contact-label">推广合作</span>
            <span class="contact-label">定制开发</span>
            <a class="email-link">codingroad@2925.com</a>
          </p>
        </div>
      </footer>
      <!-- 友情链接 -->
      <footer class="contact-section">
        <h3 class="section-title">友情链接</h3>
        <div class="contact-content">
          <p class="friend-links">
            <a href="https://www.onlinedown.net/" target="_blank" class="friend-link">华军软件园</a>
            <a href="https://www.skycn.com/home" target="_blank" class="friend-link">天空下载网</a>
            <a href="https://mydown.yesky.com" target="_blank" class="friend-link">天极下载</a>
            <a href="https://www.ddooo.com/" target="_blank" class="friend-link">多多软件站</a>
            <a href="https://www.duote.com/" target="_blank" class="friend-link">多特网</a>
          </p>
        </div>
      </footer>
      <!-- 备案信息 -->
      <footer class="beian-section">
        <div class="beian-content">
          <p>
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" class="beian-link">蜀ICP备2025121181号-1</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { getAssetUrl } from '@/config/oss';

export default {
  name: 'Home',
  data() {
    return {
      showAnnouncement: true,
      showMaintenanceModal: false, // 控制维护提示模态框的显示
      downloadDisabled: false, // 控制下载按钮的禁用状态
      showControls: false,
      isPlaying: false,
      progress: 0,
      currentTime: '0:00',
      duration: '0:00',
      isFullscreen: false,
      // 使用新的OSS资源URL
      showcaseImage: getAssetUrl('/showcase_1.5.0.png'),
      demoVideo: getAssetUrl('/videodemo.mp4'),
      videoPoster: getAssetUrl('/video_poster_1.5.0.png')
    };
  },
  methods: {
    togglePlay() {
      // 如果维护模态框显示，则不允许播放视频
      // if (this.showMaintenanceModal) {
      //   return;
      // }
      
      const video = this.$refs.videoPlayer;
      if (video.paused) {
        video.play().then(() => {
          this.isPlaying = true;
        }).catch(error => {
          console.error('播放失败:', error);
          this.isPlaying = false;
        });
      } else {
        video.pause();
        this.isPlaying = false;
      }
    },
    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      seconds = Math.floor(seconds % 60);
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    },
    updateProgress() {
      const video = this.$refs.videoPlayer;
      this.progress = (video.currentTime / video.duration) * 100;
      this.currentTime = this.formatTime(video.currentTime);
    },
    initVideo() {
      const video = this.$refs.videoPlayer;
      this.duration = this.formatTime(video.duration);
    },
    seek(event) {
      const video = this.$refs.videoPlayer;
      const progressBar = event.currentTarget;
      const clickPosition = (event.offsetX / progressBar.offsetWidth);
      video.currentTime = clickPosition * video.duration;
    },
    toggleFullscreen() {
      const video = this.$refs.videoPlayer;
      if (!document.fullscreenElement) {
        video.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    },
    handleVideoEnd() {
      const video = this.$refs.videoPlayer;
      this.isPlaying = false;
      video.load();
      this.progress = 0;
      this.currentTime = '0:00';
    },
    handleFullscreenChange() {
      this.isFullscreen = !!document.fullscreenElement;
    },
    closeAnnouncement() {
      this.showAnnouncement = false;
    },
    closeMaintenanceModal() {
      this.showMaintenanceModal = false;
      // 恢复下载功能
      this.downloadDisabled = false;
    }
  },
  mounted() {
    const video = this.$refs.videoPlayer;
    video.addEventListener('play', () => {
      this.isPlaying = true;
    });
    video.addEventListener('pause', () => {
      this.isPlaying = false;
    });
  },
  beforeDestroy() {
    const video = this.$refs.videoPlayer;
    video.removeEventListener('play', () => {});
    video.removeEventListener('pause', () => {});
  }
}
</script>

<style scoped>
/* 维护提示模态框样式 */
.maintenance-modal {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.maintenance-modal-content {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.maintenance-modal-content h3 {
  color: #e74c3c;
  margin-top: 0;
  margin-bottom: 20px;
  text-align: center;
  font-size: 22px;
}

.maintenance-message {
  margin-bottom: 25px;
  line-height: 1.6;
}

.maintenance-message p {
  margin-bottom: 15px;
}

.modal-email-link {
  color: #3498db;
  text-decoration: none;
  font-weight: bold;
}

.modal-email-link:hover {
  text-decoration: underline;
}

.maintenance-close-btn {
  display: block;
  width: 100%;
  padding: 12px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.maintenance-close-btn:hover {
  background-color: #2980b9;
}

/* 禁用下载按钮样式 */
.disabled-btn {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}

/* 禁用视频样式 */
.disabled-video {
  opacity: 0.7;
  cursor: not-allowed;
}

.video-block-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.1);
  cursor: not-allowed;
}

/* 备案信息样式 */
.beian-section {
  background-color: #f8f9fa;
  padding: 20px 0;
  margin-top: 40px;
  border-top: 1px solid #e9ecef;
  text-align: center;
}

.beian-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.beian-content p {
  margin: 0;
  font-size: 14px;
  color: #6c757d;
}

.beian-link {
  color: #6c757d;
  text-decoration: none;
  transition: color 0.3s ease;
}

.beian-link:hover {
  color: #495057;
  text-decoration: underline;
}

/* 以下是原有样式 */
</style>
